export interface tablaActivosCotizaciones {
    id: string,
    NumeroCotizacion: string;
    Fecha: string;
    Documento: string;
    Cliente: string;
    Direccion: string;
    Telefono: string;
    Email: string;
    Vrtotal: string;
    Estado
    ActionClass: string;

    
  }
  
  export const TABLAACTIVOSCOTIZACIONES: tablaActivosCotizaciones[] = [
    {
      id: "1",
      NumeroCotizacion: "31",
      Fecha: "2025-02-22",
      Documento: "1000121221",
      Cliente: "EMPRESA DE PRUEBAS",
      Direccion: "CR 56 56 56	",
      Telefono: "5160047",
      Email: "dfese@gmail.com",
      Vrtotal: "2",
      Estado: "Activo",
      ActionClass: "badge-light-success",
    },

  ]